import type Phaser from "phaser";
import { levelMapScene } from "@kit/map";
import { track } from "@kit/telemetry";
import { meta } from "./meta";
import { BaskentScene } from "./BaskentScene";
import { starTarget } from "./core/game";
import { pairCountFor } from "./core/generator";

const BaskentMap = levelMapScene({
  id: "baskent",
  gameScene: "baskent",
  title: { tr: "Başkent Eşle", en: "Capital Match" },
  accent: 0x1982c4,
  firstTheme: 2,
  track,
  describe: (n, lang) => {
    const pairs = pairCountFor(n);
    return lang === "tr" ? `${pairs} ülke–başkent çifti · ★★★ için ≤ ${starTarget(pairs)} hamle` : `${pairs} country–capital pairs · ★★★ in ≤ ${starTarget(pairs)} moves`;
  },
});

export const game: { meta: typeof meta; scenes: Phaser.Types.Scenes.SceneType[] } = {
  meta,
  scenes: [BaskentMap, BaskentScene],
};
